import { motion } from "framer-motion";
import { Button } from "../components/ui/button";
import NavBar from "../components/NavBar";
import Footer from "../components/Footer";
import { ShoppingBag, ExternalLink } from "lucide-react";

export default function Merch() {
  const shopifyUrl = "https://passivepay.myshopify.com/";

  return (
    <div className="min-h-screen bg-background">
      <NavBar />

      {/* Hero */}
      <section className="relative pt-32 pb-20 min-h-[80vh] flex items-center">
        <div className="absolute inset-0 bg-gradient-to-br from-primary/5 via-transparent to-secondary/5" />
        <div className="absolute top-1/3 right-1/3 w-96 h-96 bg-primary/10 rounded-full blur-[150px]" />

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
            >
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/10 border border-primary/20 mb-6">
                <ShoppingBag className="w-4 h-4 text-primary" />
                <span className="text-sm text-primary font-medium">Official Store</span>
              </div>

              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-heading font-black mb-6">
                PassivePay{" "}
                <span className="text-primary">Merch</span>
              </h1>

              <p className="text-lg sm:text-xl text-muted-foreground mb-8">
                Wear your investment philosophy. Premium quality apparel for the 
                passive income community.
              </p>

              <a href={shopifyUrl} target="_blank" rel="noopener noreferrer">
                <Button size="lg" className="neon-glow font-heading font-bold uppercase tracking-wider">
                  Visit Shop <ExternalLink className="ml-2 w-5 h-5" />
                </Button>
              </a>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="relative"
            >
              <div className="glass-card rounded-2xl p-8 overflow-hidden">
                <img
                  src="https://images.unsplash.com/photo-1590759483822-b2fee5aa6bd3?w=600"
                  alt="PassivePay Merch"
                  className="w-full h-80 object-cover rounded-xl"
                />
                <div className="absolute bottom-12 left-12 right-12 glass-card rounded-xl p-4">
                  <div className="flex items-center justify-between">
                    <div>
                      <div className="text-sm text-muted-foreground">Premium Collection</div>
                      <div className="font-heading font-bold">PassivePay Essentials</div>
                    </div>
                    <a href={shopifyUrl} target="_blank" rel="noopener noreferrer">
                      <Button size="sm" variant="outline" className="border-primary/50 text-primary">
                        Shop Now
                      </Button>
                    </a>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="py-20 relative bg-card/30">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-3 gap-8">
            {[
              { title: "Premium Quality", desc: "High-quality materials built to last" },
              { title: "Community Designs", desc: "Exclusive designs for PassivePay members" },
              { title: "Shipping in India", desc: "Currently shipping within India only" },
            ].map((item, i) => (
              <motion.div
                key={item.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.1 }}
                className="glass-card rounded-xl p-6 text-center"
              >
                <h3 className="font-heading font-bold mb-2">{item.title}</h3>
                <p className="text-sm text-muted-foreground">{item.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
